// クリックされたときの処理
const guideLinks = document.querySelectorAll('.guide-link a');

guideLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault(); // リンクのデフォルト動作を無効化
        const targetText = link.textContent; // リンクのテキストを取得
        const targetElements = document.querySelectorAll('p');

        targetElements.forEach((element) => {
            if (element.textContent.includes(targetText)) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
});
